<template>
  <div class="adminuers">
    <div class="can" v-if="userIfo.role !=='normal'">
      <el-table
        :data="tableData"
        style="width: 100%"
        max-height="600">
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column label='是否允许登陆'>
          <template slot-scope='scope'>
            <div :class="['switch-b switch-b2',scope.row.validStatus==='close'?'active-switch-b2':'']" @click='changeIfo("v",scope.row)'>
              <div :class="['switch-b-div',scope.row.validStatus!=='close'?'active-div':'']"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label='用户等级'>
          <template slot-scope='scope'>
            <div class="super" v-if="scope.row.userlevel === 'super'">管理员</div>
            <div class="switch-box" v-if="scope.row.userlevel !== 'super'">
              <span class="level">
                {{scope.row.userlevel!=='normal'?'主管':'普通'}}
              </span>
              <div :class="['switch-b',scope.row.userlevel!=='normal'?'active-switch-b':'']" @click='changeIfo("l",scope.row)'>
                <div :class="['switch-b-div',scope.row.userlevel!=='normal'?'active-div':'']"></div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <p>抱歉，您的权限不够。</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["userIfo"],  
  data() {
    return {
      tableData: []
    };
  },
  methods: {
    getList() {
      this.$http.user_list().then(res => {
        if (res.data.statusCode === 200) {
          this.tableData = [...res.data.result];
        }
      });
    },
    changeIfo(s, data) {
      let form = {};
      let validHold, levelHold;
      if (s === "v") {
        validHold = data.validStatus === "close" ? "open" : "close";
        form = {
          id: data.id,
          validStatus: validHold,
          userlevel: data.userlevel
        };
      } else if (s === "l") {
        levelHold = data.userlevel === "normal" ? "administrator" : "normal";
        form = {
          id: data.id,
          userlevel: levelHold,
          validStatus: data.validStatus
        };
      }
      this.$http.user_put({ ...form }).then(res => {
        if (res.data.statusCode === 200) {
          if (s === "v") {
            data.validStatus = validHold;
          } else if (s === "l") {
            data.userlevel = levelHold;
          }
        } else {
          this.$message.error("修改状态未成功");
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style>
.switch-b {
  margin-left: 20px;
  width: 40px;
  height: 22px;
  border-radius: 15px;
  background-color: rgb(11, 224, 82);
  transition: background-color 400ms;
  cursor: pointer;
  position: relative;
}
.active-switch-b {
  background-color: rgb(0, 202, 216);
}
.active-switch-b2 {
  background-color: red;
}
.switch-b-div {
  position: absolute;
  top: 50%;
  margin: 0 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #fff;
  transition: transform 400ms;
  transform: translateX(0%) translateY(-50%);
}
.active-div {
  transform: translateX(100%) translateY(-50%);
}
.switch-box {
  display: flex;
}
.sm {
  width: 100px;
}
.level {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/adminusers.vue